import sample from 'lodash/sample';

import { IconSettingsInput, IconTypeEnum } from '@/types/schema';

import { ICON_SETTINGS_COLOR_PICKER_COLOR_CONFIG } from './consts';

export function getRandomIconSettings(): IconSettingsInput {
  return {
    type: IconTypeEnum.Color,
    value: sample(Object.keys(ICON_SETTINGS_COLOR_PICKER_COLOR_CONFIG))!,
  };
}
